import { render, staticRenderFns } from "./penggunaPassword.vue?vue&type=template&id=4e4a7013&"
import script from "./penggunaPassword.vue?vue&type=script&lang=js&"
export * from "./penggunaPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports